import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.object.keys.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.regexp.match.js";
import "core-js/modules/es6.regexp.replace.js";
import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { stringify } from 'qs';
import keys from 'lodash/keys';
import * as types from './types';
import fetchCategory from '~/services/category';
var MOCK_ORIGIN_URL = 'https://mock';
export default {
  fetchContent: function fetchContent(_ref, _ref2) {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var commit, alias, query, profileId, _yield$fetchCategory, category, details, total, products, earlybirdsWidgets, currentLocale, currentQuery, currentAlias, isRedirect, redirectData, url, redirectUrl;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit = _ref.commit;
              alias = _ref2.alias, query = _ref2.query, profileId = _ref2.profileId;
              _context.next = 4;
              return fetchCategory(_this, alias, query, profileId);

            case 4:
              _yield$fetchCategory = _context.sent;
              category = _yield$fetchCategory.category;

              if (category) {
                _context.next = 9;
                break;
              }

              commit(types.SET_PRODUCTS, {
                products: [],
                total: 0
              });
              return _context.abrupt("return");

            case 9:
              details = category.details, total = category.total, products = category.products, earlybirdsWidgets = category.earlybirdsWidgets;
              currentLocale = _this.state.i18n.currentLocale;
              currentQuery = keys(query).length ? "?".concat(stringify(query)) : '';
              currentAlias = "".concat(details.slug, "-").concat(details.hash);

              if (alias !== currentAlias && process.server && details.slug !== null) {
                _this.app.context.redirect(301, "/".concat(currentLocale.market, "/").concat(currentLocale.language, "/c/").concat(currentAlias).concat(currentQuery));
              }

              isRedirect = details.routing && details.routing.isRedirect;

              if (!isRedirect) {
                _context.next = 19;
                break;
              }

              redirectData = details.routing;

              if (process.server && redirectData.newUrl) {
                _this.app.context.redirect(redirectData.httpCode, "".concat(redirectData.newUrl).concat(currentQuery));
              } else {
                url = new URL(redirectData.newUrl, MOCK_ORIGIN_URL);
                redirectUrl = url.href.replace('mock/', '');

                if (redirectUrl.match(/^\/[A-Z]{2}\/[a-z]{2}\/(?:c|e|p|q|s)\//)) {
                  _this.app.context.redirect(301, "".concat(redirectUrl).concat(currentQuery));
                } else {
                  window.location.href = "".concat(redirectUrl).concat(currentQuery);
                }
              }

              return _context.abrupt("return");

            case 19:
              commit(types.SET_DESCRIPTION, _objectSpread(_objectSpread({}, details), {}, {
                earlybirdsWidgets: earlybirdsWidgets
              }));
              commit(types.SET_PRODUCTS, {
                products: products,
                total: total
              });

            case 21:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  appendProducts: function appendProducts(_ref3, _ref4) {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var commit, alias, query, profileId, _yield$fetchCategory2, products;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              commit = _ref3.commit;
              alias = _ref4.alias, query = _ref4.query, profileId = _ref4.profileId;
              _context2.next = 4;
              return fetchCategory(_this2, alias, query, profileId);

            case 4:
              _yield$fetchCategory2 = _context2.sent;
              products = _yield$fetchCategory2.category.products;
              commit(types.APPEND_PRODUCTS, products);

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  prependProducts: function prependProducts(_ref5, _ref6) {
    var _this3 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var commit, alias, query, profileId, _yield$fetchCategory3, products;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              commit = _ref5.commit;
              alias = _ref6.alias, query = _ref6.query, profileId = _ref6.profileId;
              _context3.next = 4;
              return fetchCategory(_this3, alias, query, profileId);

            case 4:
              _yield$fetchCategory3 = _context3.sent;
              products = _yield$fetchCategory3.category.products;
              commit(types.PREPEND_PRODUCTS, products);

            case 7:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  }
};